import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { IconButtonComponent } from '../../buttons/icon-button/icon-button.component';

@Component({
  selector: 'app-button-card',
  templateUrl: './button-card.component.html',
  styleUrl: './button-card.component.scss',
  imports: [IconButtonComponent, MatSlideToggleModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonCardComponent {
  cardStyle = input.required<'warning' | 'negative'>();
  title = input.required<string>();
  bodyLine1 = input.required<string>();
  bodyLine2 = input<string | undefined>(undefined);
  controlType = input<'button' | 'toggle'>('button');
  isDisabled = input<boolean>(false);

  // Button-specific
  buttonLabel = input<string>('');
  buttonId = input<string>('');
  iconName = input<string>('');

  // Toggle-specific
  toggleId = input<string>('');
  toggleValue = input<boolean>(false);

  buttonClicked = output<void>();
  toggleChanged = output<boolean>();

  protected iconButtonStyle = computed<'pause' | 'negative'>(() =>
    this.cardStyle() === 'warning' ? 'pause' : 'negative',
  );
}
